/**
 * @generated SignedSource<<55c672f179a1a45a2bc648fd6c35dc13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TextWithFieldPickerQuery$variables = {
  list: string;
  siteUrl: string;
};
export type TextWithFieldPickerQuery$data = {
  readonly getSharePointListFields: ReadonlyArray<{
    readonly displayName: string;
    readonly fieldType: number;
    readonly internalName: string;
  }> | null | undefined;
};
export type TextWithFieldPickerQuery = {
  response: TextWithFieldPickerQuery$data;
  variables: TextWithFieldPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "list"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteUrl"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "listId",
        "variableName": "list"
      },
      {
        "kind": "Variable",
        "name": "siteUrl",
        "variableName": "siteUrl"
      }
    ],
    "concreteType": "SharePointListField",
    "kind": "LinkedField",
    "name": "getSharePointListFields",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fieldType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "internalName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TextWithFieldPickerQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TextWithFieldPickerQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8d85f25686ea22fe18dd9c5772af0979",
    "id": null,
    "metadata": {},
    "name": "TextWithFieldPickerQuery",
    "operationKind": "query",
    "text": "query TextWithFieldPickerQuery(\n  $siteUrl: String!\n  $list: String!\n) {\n  getSharePointListFields(siteUrl: $siteUrl, listId: $list) {\n    displayName\n    fieldType\n    internalName\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8f04252115216a54e57380888f0d11a";

export default node;
